  import {
    gsap,
  } from 'gsap/all';

  export default class {
    constructor() {
      let that = this;

      this.tabOptionsContainer = document.querySelector(".ifit-trainers-tabs__options-container");
      this.spaceFromWindow = document.querySelector(".ifit-trainers-tabs__options").getBoundingClientRect().x;
      this.blueBar = document.querySelectorAll(".ifit-trainers-tabs__blue-bar");
      this.tabOptions = document.querySelectorAll(".ifit-trainers-tabs__option");
      this.activeTabOption = document.querySelector(".ifit-trainers-tabs__option.active");
      this.tabContents = document.querySelectorAll(".ifit-trainers-tabs__content");
      this.activeTabContent = document.querySelector(".ifit-trainers-tabs__content.active");

      this.tabOptions.forEach(option => {
        option.addEventListener('click', event => {
          //change active class to options
          this.changeActiveOption(option);

          //move bluebar
          this.moveBluebar();

          //show active content\
          this.changeActiveContent(option.dataset.target);
        });
      });

      window.addEventListener('resize', this.onResize.bind(this));

      this.moveBluebar();
      this.onResize();

    }

    moveBluebar() {
      gsap.to(this.blueBar, {
        x: this.activeTabOption.getBoundingClientRect().x - this.spaceFromWindow + this.tabOptionsContainer.scrollLeft,
        ease: "ease",
        duration: .2
      });
    }

    changeActiveOption(option) {
      this.tabOptions.forEach(item => {
        item.classList.remove('active');
      });
      option.classList.add('active');
      this.activeTabOption = document.querySelector(".ifit-trainers-tabs__option.active");
    }

    changeActiveContent(id) {
      this.tabContents.forEach(item => {
        item.classList.remove('active');
      });
      document.querySelector(id).classList.add('active');
      this.activeTabContent = document.querySelector(".ifit-trainers-tabs__content.active");
    }

    onResize() {
      this.spaceFromWindow = document.querySelector(".ifit-trainers-tabs__options").getBoundingClientRect().x;
      this.moveBluebar();
    }
  }
